"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var storage = new _GatewayService["default"]('user-note-service');

var fetchNote = function fetchNote(userKey, noteContainerKey) {
  return storage.get("notes/".concat(userKey, "/").concat(noteContainerKey));
};

var writeNote = function writeNote(userKey, noteContainerKey, noteText) {
  return storage.post("notes/".concat(userKey, "/").concat(noteContainerKey), noteText, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var deleteNote = function deleteNote(userKey, noteContainerKey) {
  return storage["delete"]("notes/".concat(userKey, "/").concat(noteContainerKey));
};

var _default = {
  fetchNote: fetchNote,
  writeNote: writeNote,
  deleteNote: deleteNote
};
exports["default"] = _default;